import React from 'react';
import './showListBtn.scss';
import { PodTextS16W500Lh30 } from '../../texts/fontText/podkova/TextPodkova';

interface IShowListBtn {
  addList: () => void;
}

const ShowListBtn = ({ addList }: IShowListBtn) => {
  return (
    <div
      className="showListBtn flex ai-center jc-between"
      onClick={addList}
    >
      <PodTextS16W500Lh30 text={'SHOW MORE LIST'} />
      <img src="/seamansclub-news/assets/svg/right_arrow.svg" alt="temp" width={12} height={12} />
    </div>
  );
};

export default ShowListBtn;